var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#fff"},[React.createElement("path",{"d":"m0 0h5v25h-5z","key":0}),React.createElement("path",{"d":"m9 0h5v25h-5z","key":1})]));
}

Pause.defaultProps = {"height":"25","viewBox":"0 0 14 25","width":"14"};

module.exports = Pause;

Pause.default = Pause;
